export default __webpack_public_path__ + "static/media/paypal.5aebe1ba.svg";